import React from 'react';
import moment from 'moment';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetParamsDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  ParamsGroupObj,
  ParamsNameObj,
} from '../../../common/spdCore/validation/schemas';

interface ParamsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const paramsForGrid = (param: GetParamsDto) => {
  const getValue = () => {
    switch (param.type) {
      case 'String':
        return param.valueString || '';
      case 'Boolean':
        return param.valueBoolean ? 'TAK' : 'NIE';
      case 'Number':
        return param.valueNumber?.toString() || '';
      case 'Date':
        return param.valueDate
          ? moment(param.valueDate).locale('pl').format('LLL')
          : '';
      default:
        return '';
    }
  };
  return {
    key: param.id,
    values: {
      group_text: ParamsGroupObj[param.group],
      name_text: ParamsNameObj[param.name],
      'params.type': param.type,
      'params.value': getValue(),
      'params.isEditable': param.isEditable ? 'TAK' : 'NIE',
      'owner.name': param.owner?.name || '',
    },
    isInactive: !param.isVisible,
  };
};

export const ParamsSearch: React.FC<ParamsSearchProps> = props => {
  const columns: GridColumn[] = [
    { header: 'Grupa', property: 'group_text' },
    { header: 'Nazwa', property: 'name_text' },
    {
      header: 'Typ',
      property: 'params.type',
      noFilter: true,
    },
    {
      header: 'Wartość',
      property: 'params.value',
      noFilter: true,
      noSorting: true,
    },
    {
      header: 'Edytowalny',
      property: 'params.isEditable',
      noFilter: true,
    },
    { header: 'Użytkownik', property: 'owner.name' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="params.name"
      initialOrderDirection="ASC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={'Brak parametrów do wyświetlenia'}
      onRowClick={props.onRowClick}
      withHistory={true}
      refresh={props.refresh}
      withFilterInColumns={true}
    />
  );
};
